import {Component} from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  children: PropTypes.func,
  dataSource: PropTypes.func,
  url: PropTypes.string,
  onError: PropTypes.func
};

/** @extends {Component<PropTypes.InferProps<typeof propTypes>>} */
export default class Fetch extends Component {
  static displayName = 'Fetch';
  static propTypes = propTypes;

  state = {
    data: null
  };

  componentDidMount() {
    this.mounted = true;
    window
      .fetch(this.props.url)
      .then(res => res.json())
      .then(data => this.mounted && this.setState({data}))
      .catch(
        err => this.mounted && this.props.onError && this.props.onError(err)
      );
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  render() {
    return this.props.children && this.props.children(this.state.data);
  }
}
